import React from 'react'

import MediaAvatar from '../../MediaAvatar'

import { getFormatted } from '../../../../utilities/phoneNumber'
import { useUserAPI } from '../../../../providers/UserAPIProvider'
import useStyles from './styles'

type OptionProps = {
  id: string
}

const Option: React.FC<OptionProps> = ({ id }) => {
  const { allUsers } = useUserAPI()

  const user = React.useMemo(() => allUsers[id], [allUsers, id])

  const verifiedChannels = React.useMemo(() => {
    if (!user) {
      return []
    }

    const verified = user.channels.filter(channel => Boolean(channel.validated))

    // Sort so emails are shown first, then phones, and onwards
    const order: APIChannel['type'][] = ['email', 'sms_voice', 'voice_only']
    const sorted = verified.sort((a, b) => {
      const aIdx = order.indexOf(a.type)
      const bIdx = order.indexOf(b.type)
      return aIdx - bIdx
    })
    return sorted
  }, [user])

  const channelDisplay = React.useMemo(() => {
    const asStrings = verifiedChannels.slice(0, 5).map(channel => {
      const { type, value } = channel

      if (type === 'email') {
        return value
      }

      return getFormatted(value)
    })

    return asStrings.join(', ')
  }, [verifiedChannels])

  const classes = useStyles()

  if (!user) {
    return null
  }

  return (
    <div className={classes.root}>
      <div className={classes.nameArea}>
        <div className={classes.avatarHolder}>
          <MediaAvatar user={user} className={classes.avatar} />
        </div>

        {user.name}
      </div>

      <div className={classes.channels}>
        ({verifiedChannels.length > 0 ? channelDisplay : 'No verified channels'}
        )
      </div>
    </div>
  )
}

export default Option
